class ProductCompare extends HTMLElement {
  connectedCallback() {
    // Die Tabs stehen im Markup, sobald Desktop ODER Handy umschaltet. In welcher
    // Breite sie sichtbar sind, entscheidet das CSS – hier reicht: gibt es welche?
    this.tabs = Array.from(this.querySelectorAll('.product-compare__tab'));
    if (this.tabs.length === 0) return;

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  onClick = (event) => {
    const tab = event.target.closest('.product-compare__tab');
    if (!tab || !this.contains(tab)) return;

    this.select(this.tabs.indexOf(tab));
  };

  onKeydown = (event) => {
    const tab = event.target.closest('.product-compare__tab');
    if (!tab || !this.contains(tab)) return;

    const current = this.tabs.indexOf(tab);
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = (current + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = (current - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  };

  select(index) {
    if (index < 0 || index >= this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.querySelectorAll('.product-compare__cell[data-column]').forEach((cell) => {
      cell.classList.toggle('is-active', Number(cell.dataset.column) === index);
    });
  }
}

if (!customElements.get('product-compare')) {
  customElements.define('product-compare', ProductCompare);
}
